// extracted by mini-css-extract-plugin
export var box = "marusya-module--box--wNz8H";
export var img = "marusya-module--img--KPk02";
export var svg = "marusya-module--svg--ON4j3";